/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { Steps, Result } from "antd";
import USCanadaFilesModals from "./USCandaFileUploads";
import OtherPassportsFileModal from "./OtherPassportsFileModal";
import CanadaFlag from "../../assets/images/canada_flag.jpeg";
import USAFlag from "../../assets/images/usa-flag-img.jpeg";
import ZelleIcon from "../../assets/images/zelle_logo.svg";
import CreditCardIcon from "../../assets/images/credit_card.png";
import ChequeIcon from "../../assets/images/cheque2.png";
import MailICon from "../../assets/images/mail.png";
import WhatsappIcon from "../../assets/images/whatsapp.png";
import { isEmpty } from "lodash";
import { List } from "antd";
import { Card, Checkbox, Divider } from "antd";
import { useSelector } from "react-redux";
import { appRoutesConst } from "app/navigation";
import { Link } from "react-router-dom";
import TermsAndAckowledgeCheckbox from "components/common/TermsAndAckowledgeCheckbox";
const steps = [
  {
    title: "Details and Documents Upload",
    description: "Details and Documents Upload",
  },
  {
    title: "Payment for E-Visa",
    description: "Payment",
  },
  {
    title: "Done",
    description: "Payment",
    status: "success",
  },
];
export default function EvisaForm(props) {
  console.log("props", props.errors);
  const [current, setCurrent] = useState(0);
  //states
  const [state, setState] = useState({
    showUsCanadaPassportModal: false,
    showOtherPassportModal: false,
    usCanadaPassports: [],
    otherPassports: [],
    usCanadaUploads: [],
    otherPassportsUploads: [],
  });

  // const { usCanadaPassports, otherPassports } = useSelector(
  //   (state) => state.flightSearch
  // );
  const { evisaData } = useSelector((state) => state.localStore);

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const next = () => {
    setCurrent(current + 1);
  };
  const handleUSCandaModal = () => {
    setState({
      ...state,
      showUsCanadaPassportModal: !state.showUsCanadaPassportModal,
    });
  };

  const handleOtherPassportModal = () => {
    setState({
      ...state,
      showOtherPassportModal: !state.showOtherPassportModal,
    });
  };

  const getUSCanadaPassports = (uploads) => {
    console.log("getUSCanadaPassports", uploads);
    props.getUSCanadaPassports(uploads);
    // usCanadaUploads(uploads)
    setState({ ...state, usCanadaUploads: uploads });
  };

  const getOtherPassports = (uploads) => {
    console.log("getOtherPassports", uploads);

    props.getOtherPassports(uploads);
    setState({ ...state, otherPassportsUploads: uploads });
  };

  console.log("evisaData", evisaData);

  return (
    <div style={{ margin: 0 }} className="user-details mt-3">
      <div className="user-details-title position-relative mt-0">
        <p className="position-relative font-weight-semibold user-border mb-0">
          E-Visa Application Form
        </p>
      </div>

      <Steps current={current} status="finish" items={items} />
      <div className="mt-3">
        {/* <button
          onClick={() => {
            setCurrent(0);
            props.clearEvisaForm();
          }}
          style={{ background: "none" }}
        >
          <i className="fa fa-close mr-1" />
          <span>Clear Evisa Form</span>
        </button> */}
        {current === 0 && props.userDetailsForm()}
        <div className="user-detail-search-form custom-d-inline-block mt-30">
          {current === 0 && (
            <>
              <Row className="g-3 mt-3">
                <Col>
                  <FloatingLabel controlId="floatingInputGrid">
                    <span className="font-weight-500 d-none justify-content-md-between">
                      <span>US/Canada Passports</span> <span></span>
                    </span>
                    <Form.Select
                      onChange={(e) => {
                        props.handleChange(e);
                        // handleUSCandaModal();
                        setState({ ...state, showUsCanadaPassportModal: true });
                      }}
                      value={props.passport_type}
                      name="passport_type"
                      aria-label="Default select example"
                    >
                      <option value={""} selected disabled>
                        Select Total No. Of US/Canada Passports
                      </option>
                      {[...Array(10)].map((d, index) => {
                        return (
                          <option key={index} value={index + 1}>
                            {index + 1}
                          </option>
                        );
                      })}
                    </Form.Select>
                    {props.passport_type > 0 && (
                      <span className="font-weight-500 d-none justify-content-md-between mt-2">
                        <span> </span>{" "}
                        <a
                          onClick={() => {
                            setState({
                              ...state,
                              showUsCanadaPassportModal: true,
                            });
                          }}
                          className="cursor-pointer"
                        >
                          <i className="fa fa-edit"></i> Edit
                        </a>
                      </span>
                    )}
                  </FloatingLabel>
                  <USCanadaFilesModals
                    show={state.showUsCanadaPassportModal}
                    handleClose={handleUSCandaModal}
                    passportCount={parseInt(props.passport_type)}
                    getUSCanadaPassports={getUSCanadaPassports}
                  />

                  {props.errors && (
                    <span className="text-danger">
                      {props.errors.passport_type}
                    </span>
                  )}
                  <br />
                  {/* {props.errors && (
                    <span className="text-danger">
                      {props.errors.passports}
                    </span>
                  )} */}
                </Col>
                <Col md>
                  <FloatingLabel
                    controlId="floatingInputGrid"
                    // label="Passport Type"
                  >
                    <span className="font-weight-500  justify-content-md-between d-none">
                      <span> Foreign Passports</span> <span></span>
                    </span>
                    <Form.Select
                      onChange={(e) => {
                        props.handleChange(e);
                        // handleUSCandaModal();
                        setState({ ...state, showOtherPassportModal: true });
                      }}
                      value={props.other_passport_type}
                      name="other_passport_type"
                      aria-label="Default select example"
                    >
                      <option value={""} selected disabled>
                        Select Total No. Of Foreign Passports
                      </option>
                      {[...Array(10)].map((d, index) => {
                        return (
                          <option key={index} value={index + 1}>
                            {index + 1}
                          </option>
                        );
                      })}
                    </Form.Select>
                    {props.other_passport_type > 0 && (
                      <span className="font-weight-bold display-flex justify-content-md-between mt-2">
                        <span> </span>{" "}
                        <a
                          onClick={() => {
                            setState({
                              ...state,
                              showOtherPassportModal: true,
                            });
                          }}
                          className="cursor-pointer"
                        >
                          <i className="fa fa-edit"></i> Edit
                        </a>
                      </span>
                    )}
                  </FloatingLabel>

                  <OtherPassportsFileModal
                    show={state.showOtherPassportModal}
                    handleClose={handleOtherPassportModal}
                    passportCount={parseInt(props.other_passport_type)}
                    getOtherPassports={getOtherPassports}
                  />

                  {props.errors && (
                    <span className="text-danger">
                      {props.errors.other_passport_type}
                    </span>
                  )}
                  <br />

                  {/* {props.errors && (
                    <span className="text-danger">
                      {props.errors.other_passports}
                    </span>
                  )} */}
                </Col>
                <Col md className="d-none d-lg-block"></Col>
              </Row>
              <Row>
                <div className="dates-checkbox-container mb-30">
                  <TermsAndAckowledgeCheckbox
                    onlyAlerts={true}
                    // handleCheckbox={handleCheckbox}
                  />
                  <Checkbox
                    onChange={(e) => {
                      props.handleCheckbox(e, "isTermsAccepted");
                    }}
                    className="date-checkbox"
                    checked={props?.isTermsAccepted}
                  >
                    <span className=" font-weight-500 text-capitalize">
                      I read and agreed to the{" "}
                      <Link
                        target="_blank"
                        to={appRoutesConst.termsandconditions}
                      >
                        {" "}
                        Terms and Conditions
                      </Link>{" "}
                      by{" "}
                      <span className="font-weight-semibold">
                        Chicago Hajj & Umrah.
                      </span>
                    </span>
                  </Checkbox>
                </div>
                {props.errors && (
                  <span className="text-danger">
                    {props.errors.isTermsAccepted}
                  </span>
                )}
              </Row>
            </>
          )}
          {current === 1 && (
            <div className="payment-list-container">
              <div className="edit-evisa-btn-container">
                <button
                  onClick={() => {
                    setCurrent(0);
                    props.clearEvisaForm();
                  }}
                  style={{ background: "none" }}
                >
                  <i className="fa fa-close mr-1" />
                  <span>Clear Evisa Form</span>
                </button>
              </div>
              <List>
                <List.Item
                  style={{
                    background: "#eceef1",
                  }}
                >
                  <List.Item.Meta
                    // avatar={<Avatar src={item.picture.large} />}
                    title={
                      <div className="list-title-container">
                        <span className="ml-0">Your e-Visa charges</span>
                      </div>
                    }

                    // description={"No Of Passports : 2 (2 x $200)"}
                  />
                  <div className="font-weight-bold">Total</div>
                </List.Item>
                {!isEmpty(evisaData.passportLength) && (
                  <List.Item>
                    <List.Item.Meta
                      // avatar={<Avatar src={item.picture.large} />}
                      title={
                        <div className="list-title-container d-md-flex align-items-center">
                          <span className="list-image-container">
                            <img src={USAFlag} alt="USA Flag" />
                            <img
                              className="ml-2"
                              src={CanadaFlag}
                              alt="Canada Flag"
                            />
                          </span>
                          <div className="visa-desc">
                            <div className="ml-md-3 ">
                              {"US/Canada Passports ($200)"}
                            </div>
                            <div className="ant-list-item-meta-description ml-md-3">
                              {" "}
                              description=
                              {`No Of Passports : ${evisaData.passportLength} (${evisaData.passportLength} x $200)`}
                            </div>
                          </div>
                        </div>
                      }
                      // description={`No Of Passports : ${evisaData.passportLength} (${evisaData.passportLength} x $200)`}
                    />
                    <div className="font-weight-bold">
                      ${parseInt(evisaData.passportLength, 10) * 200}
                    </div>
                  </List.Item>
                )}
                {!isEmpty(evisaData.otherNationalityPassportLength) && (
                  <List.Item style={{ borderBottom: "none" }}>
                    <List.Item.Meta
                      // avatar={<Avatar src={item.picture.large} />}
                      title={
                        <a href="https://ant.design">
                          {"Other Nationalities Passports ($350)"}
                        </a>
                      }
                      description={`No Of Passports : ${evisaData.otherNationalityPassportLength} (${evisaData.otherNationalityPassportLength} x $350)`}
                    />
                    <div className="font-weight-bold">
                      $
                      {parseInt(evisaData.otherNationalityPassportLength, 10) *
                        350}
                    </div>
                  </List.Item>
                )}
                <Divider orientation="center"> Total </Divider>
                <List.Item>
                  <List.Item.Meta
                    // avatar={<Avatar src={item.picture.large} />}
                    title={
                      <a href="https://ant.design">{"Total Amount Due"}</a>
                    }
                    description={`Total No. Of Passports : ${
                      parseInt(
                        isEmpty(evisaData.otherNationalityPassportLength)
                          ? 0
                          : evisaData.otherNationalityPassportLength,
                        10
                      ) +
                      parseInt(
                        isEmpty(evisaData.passportLength)
                          ? 0
                          : evisaData.passportLength,
                        10
                      )
                    } `}
                  />
                  <div className="font-weight-bold">
                    $
                    {parseInt(
                      isEmpty(evisaData.otherNationalityPassportLength)
                        ? 0
                        : evisaData.otherNationalityPassportLength,
                      10
                    ) *
                      350 +
                      parseInt(
                        isEmpty(evisaData.passportLength)
                          ? 0
                          : evisaData.passportLength,
                        10
                      ) *
                        200}
                  </div>
                </List.Item>
              </List>
              <Divider style={{ border: 3 }} orientation="left">
                {" "}
                Payment Options{" "}
              </Divider>
              <div className="text-center mt-30">
                <div className="site-card-wrapper">
                  {/* Start New Design for the payment */}
                  <div className="row">
                    <div className="col-md-4 payment-item">
                      <Card
                        // style={{ height: "16rem" }}
                        className="mt-3 cursor-pointer first-payment-card"
                        bordered={false}
                        onClick={() => props.handleCreditCard(evisaData)}
                      >
                        <img
                          // style={{ width: "25%" }}
                          src={CreditCardIcon}
                          alt="Credit Card Icon"
                          className="mb-4"
                        />
                        <p className="font-weight-bold  mt-lg-4 mt-md-3 mt-2">
                          Pay with your Card
                        </p>
                      </Card>
                    </div>
                    <div className="col-md-4 payment-item">
                      <Card
                        // style={{ height: "16rem" }}
                        className="mt-3 second-payment-card"
                        bordered={false}
                      >
                        <img
                          // style={{ width: "25%" }}
                          src={ZelleIcon}
                          alt="Zelle Icon"
                          className="img-fluid payment-img mb-4"
                        />
                        <p className="font-weight-bold mt-lg-4 mt-md-3 mt-2">
                          Zell to <a href="tel:7736804700">(773) 680-4700</a> /{" "}
                          <br />
                          <a
                            href="mailto:zamir@chicagohajj.com"
                            className="d-block"
                          >
                            zamir@chicagohajj.com
                          </a>{" "}
                        </p>
                      </Card>
                    </div>
                    <div className="col-md-4 payment-item">
                      <Card
                        className="mt-3 third-payment-card"
                        bordered={false}
                      >
                        <img
                          // style={{ width: "25%" }}
                          src={ChequeIcon}
                          alt="Cheque Icon"
                          className="mb-3 "
                        />
                        <p
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                          }}
                          className="font-weight-bold mt-lg-4 mt-md-3 mt-2 font-size-14 text-capitalize"
                        >
                          <span>
                            Issue a check in favor of Chicago Hajj & Umrah then
                            take a clear picture of front side and send it at{" "}
                          </span>
                        </p>
                        <p>
                          <span className="ml-1 mr-1">
                            <img
                              style={{ width: 25 }}
                              src={MailICon}
                              alt="Email Icon"
                            />
                            <a
                              className="ml-1 mr-1 font-weight-bold font-size-14"
                              href="mailto:info@chicagohajj.com"
                              target={"_blank"}
                              rel="noreferrer"
                            >
                              info@chicagohajj.com
                            </a>
                          </span>
                          <span>
                            <img
                              style={{ width: 25 }}
                              src={WhatsappIcon}
                              alt="Whatsapp Icon"
                            />
                            <a
                              className="ml-1 font-weight-bold font-size-14"
                              href="https://api.whatsapp.com/send?phone=17736350080&text=%E2%80%9CI%20want%20to%20find%20about%20your%20Umrah%20E-visa%20only%20or%20Customized%20Umrah%20package%20or%20Hajj%20service%E2%80%9D%20Please%20select%20what%20service%20you%20want"
                              target={"_blank"}
                              rel="noreferrer"
                            >
                              (773) 635-0080
                            </a>
                          </span>
                        </p>
                        {/* <p style={{ display: "flex" }} className="flex-nowrap">
                         
                        
                        </p> */}
                      </Card>
                    </div>
                  </div>
                  {/* End New Design for the payment */}
                </div>
              </div>
            </div>
          )}
          {current === 2 && (
            <Result
              status="success"
              title="Payment Done Successfully"
              subTitle="You Can Submit The Form"
            />
          )}
          {current === 0 && (
            <div className="search-button process-btn-section position-relative text-center">
              <button
                disabled={props.submitting}
                className="btn btn-primary"
                onClick={() => {
                  props.handleEvisaSubmit(next);
                }}
              >
                {props.submitting ? "Loading..." : ` Proceed with payment`}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
